// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../../css/Theme.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as SignUpSteps from "./SignUpSteps.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var progressIndicatorStyle = Curry._1(BsCss.style, {
      hd: BsCss.flexGrow(1),
      tl: {
        hd: BsCss.marginRight(BsCss.px(4)),
        tl: {
          hd: BsCss.borderBottomWidth(BsCss.px(4)),
          tl: {
            hd: BsCss.borderRadius(BsCss.px(10)),
            tl: /* [] */0
          }
        }
      }
    });

var currentStepsStyle = Cn.make([
      progressIndicatorStyle,
      Curry._1(BsCss.style, {
            hd: BsCss.borderColor(Theme.Color.red400),
            tl: /* [] */0
          })
    ]);

var remainingStepsStyle = Cn.make([
      progressIndicatorStyle,
      Curry._1(BsCss.style, {
            hd: BsCss.borderColor(Theme.Color.gray100),
            tl: /* [] */0
          })
    ]);

function makeStepMarkup(stepIndex, stepsIter) {
  if (stepsIter <= stepIndex) {
    return JsxRuntime.jsx("div", {
                className: currentStepsStyle
              }, "step" + String(stepsIter));
  } else {
    return JsxRuntime.jsx("div", {
                className: remainingStepsStyle
              }, "step" + String(stepsIter));
  }
}

function ProgressIndicator(props) {
  var partial_arg = SignUpSteps.getStepIndex(props.step);
  return JsxRuntime.jsx("div", {
              children: Belt_Array.map(Belt_Array.range(1, 5), (function (param) {
                      return makeStepMarkup(partial_arg, param);
                    })),
              className: "flex mb-4"
            });
}

var make = ProgressIndicator;

export {
  progressIndicatorStyle ,
  currentStepsStyle ,
  remainingStepsStyle ,
  makeStepMarkup ,
  make ,
}
/* progressIndicatorStyle Not a pure module */
